var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82.017,
    viewBox: "0 0 82 82.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift_card",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8454",
    "data-name": "Path 8454",
    d: "M65.208,53H7.125A5.131,5.131,0,0,1,2,47.875V13.708A1.709,1.709,0,0,1,3.708,12H68.625a1.709,1.709,0,0,1,1.708,1.708V47.875A5.131,5.131,0,0,1,65.208,53ZM5.417,15.417V47.875a1.713,1.713,0,0,0,1.708,1.708H65.208a1.713,1.713,0,0,0,1.708-1.708V15.417Z",
    transform: "translate(4.833 29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8455",
    "data-name": "Path 8455",
    d: "M76.875,27.5H5.125A5.131,5.131,0,0,1,0,22.375V12.125A5.131,5.131,0,0,1,5.125,7h71.75A5.131,5.131,0,0,1,82,12.125v10.25A5.131,5.131,0,0,1,76.875,27.5ZM5.125,10.417a1.713,1.713,0,0,0-1.708,1.708v10.25a1.713,1.713,0,0,0,1.708,1.708h71.75a1.713,1.713,0,0,0,1.708-1.708V12.125a1.713,1.713,0,0,0-1.708-1.708Z",
    transform: "translate(0 16.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M13.209,27.333a1.709,1.709,0,0,1-1.691-1.947C11.555,25.13,15.375,0,35.417,0c8.829,0,11.962,4.77,11.962,8.853,0,7.674-10.6,18.481-34.17,18.481ZM35.417,3.417C21.368,3.417,16.578,18.4,15.3,23.882c18.72-.581,28.666-8.938,28.666-15.03a4.445,4.445,0,0,0-1.893-3.707,11.134,11.134,0,0,0-6.652-1.729Z",
    transform: "translate(27.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M36.17,27.333C12.6,27.333,2,16.526,2,8.853a7.906,7.906,0,0,1,3.256-6.44A14.433,14.433,0,0,1,13.962,0C34,0,37.824,25.13,37.861,25.386a1.709,1.709,0,0,1-1.691,1.947ZM13.962,3.417C8.69,3.417,5.417,5.5,5.417,8.853c0,6.1,9.953,14.453,28.683,15.033C32.859,18.368,28.189,3.417,13.962,3.417Z",
    transform: "translate(4.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M13.208,65.083A1.709,1.709,0,0,1,11.5,63.375V8.708a1.708,1.708,0,0,1,3.417,0V63.375A1.709,1.709,0,0,1,13.208,65.083Z",
    transform: "translate(27.792 16.917)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift_card.d2b6277c7f235790f95d8118a971ee94.svg";
export { ForwardRef as ReactComponent };